import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, useTheme } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import DashboardLayout from '../DashboardLayout';
import { UPDATE_CUSTOMER_ORDERS_PATH } from '../../pages/UpdateCustomerOrders/constants';

function MainLayout({ children, withoutLayout }) {
    const [showSmallSizeMenu, setShowSmallSizeMenu] = useState(false);

    const { user, isAuthenticated, getUserDetailsNotAsync, refreshSessionData, isConfinedToOrderUpdate } = useAuth();
    const [authenticated, setAuthenticated] = useState(false);
    const [confined, setConfined] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const location = useLocation();
    const theme = useTheme();
    let userData = getUserDetailsNotAsync();
    const [loadedSession, setLoadedSession] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            let authenticated = await isAuthenticated();

            // if (userData.application === 'preview') {
            //     setLoadedSession(false);
            // } else {
            //     setLoadedSession(true);
            // }
            try {
                if (authenticated) {
                    let value = await refreshSessionData();
                    userData = value;
                }

                setLoadedSession(true);
            } catch {
                setLoadedSession(true);
            } finally {
                setLoadedSession(true);
            }
        };
        checkAuth();
    }, []);

    useEffect(() => {
        const checkAuth = async () => {
            setLoaded(false);
            try {
                // Non-Portal-Enabled contacts are confined to the billing page; bounce
                // them there instead of showing the dashboard.
                const isConfined = await isConfinedToOrderUpdate();
                setConfined(isConfined);
                if (!isConfined) {
                    let value = await isAuthenticated();
                    setAuthenticated(value);
                }
            } catch {
                setConfined(false);
                setAuthenticated(false);
            } finally {
                setLoaded(true);
            }
        };
        checkAuth();
    }, [location.pathname]);

    // useEffect(() => {
    //     document.body.style.backgroundColor = theme.palette.background.neutralSecondary;
    // }, [location.pathname]);

    if (!loaded || !loadedSession) {
        return null;
    }

    if (confined) {
        return <Navigate to={UPDATE_CUSTOMER_ORDERS_PATH} replace />;
    }

    if (authenticated) {
        if (!userData?.contact?.agreedToPortalTerms) {
            return (
                <Navigate
                    to={'/terms' + (location.search ? location.search : '') + (location.hash ? location.hash : '')}
                    state={{
                        path: location.pathname + location.search + location.hash,
                        query: (location.search ? location.search : '') + (location.hash ? location.hash : ''),
                    }}
                />
            );
        }

        return (
            <>
                {!withoutLayout && (
                    <DashboardLayout showSmallSizeMenu={showSmallSizeMenu} setShowSmallSizeMenu={setShowSmallSizeMenu}>
                        {children}
                    </DashboardLayout>
                )}
                {withoutLayout && <>{children}</>}
            </>
        );
    } else {
        //if user not authenticated
        return (
            <Navigate
                to={'/signout' + (location.search ? location.search : '') + (location.hash ? location.hash : '')}
                state={{
                    path: location.pathname + location.search + location.hash,
                    query: (location.search ? location.search : '') + (location.hash ? location.hash : ''),
                }}
            />
        );
    }
}

export default MainLayout;
